import { FC } from 'react';

import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Col, Typography } from 'antd';

import { DataCard } from 'modules/ui';
import {
    CurrentFloor,
    selectors as elevatorsSelectors,
    useSubscribeElevatorFloorHistory,
} from 'modules/entities/modules/elevators';

import { card } from './LiveLocation.rules';

import LiveLocationContent from '../LiveLocationContent';
import { selectCurrentFloor } from 'modules/elevator-detail/services/selectors/floorActivity';

const hasValidCurrentFloor = (currentFloor: CurrentFloor | null | undefined) =>
    Boolean(currentFloor && Number.isFinite(currentFloor.floor) && currentFloor.time && !Number.isNaN(Date.parse(currentFloor.time)));

const normalizeCurrentFloor = (currentFloor: CurrentFloor | null | undefined): CurrentFloor | null => {
    if (!currentFloor?.time) {
        return currentFloor ?? null;
    }

    return {
        ...currentFloor,
        time: currentFloor.time
            .replace(' ', 'T')
            .replace(/(\.\d{3})\d+$/, '$1')
            .replace(/(\.\d{3})$/, '$1Z'),
    };
};

const LiveLocation: FC<{ isDeactivated?: boolean }> = ({ isDeactivated = false }) => {
    const { inProgress, success } = useSelector(elevatorsSelectors.selectElevatorApi);
    const { id } = useParams<{ id: string }>();
    const subscribedCurrentFloor = useSubscribeElevatorFloorHistory(id);
    const floorActivityCurrentFloor = normalizeCurrentFloor(useSelector(selectCurrentFloor) as CurrentFloor | null);
    let currentFloor: CurrentFloor | null = hasValidCurrentFloor(subscribedCurrentFloor)
        ? subscribedCurrentFloor
        : floorActivityCurrentFloor;

    if (success && !currentFloor) {
        return null;
    }

    if (isDeactivated && !currentFloor) {
        currentFloor = { time: '2023-02-27T11:25:24.000Z', floor: 4 };
    }

    if (isDeactivated) {
        return <div />;
    }

    return (
        <Col xs={24} lg={12} xl={24}>
            <DataCard
                style={{ filter: isDeactivated ? 'blur(1px)' : 'none' }}
                title={
                    <Typography.Title level={4}>
                        <FormattedMessage id="page.elevatorDetail.tabs.iotData.liveLocation.heading" />
                    </Typography.Title>
                }
                loading={inProgress}
                extend={{
                    card,
                }}
            >
                {currentFloor && <LiveLocationContent currentFloor={currentFloor} isDeactivated={isDeactivated} />}
            </DataCard>
        </Col>
    );
};

export default LiveLocation;
